'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  CRYPTO: 'CRYPTO',
  FIAT: 'FIAT',
  FUTURE: 'FUTURE',
  OPTION: 'OPTION'
};